export const encode = (obj: unknown) => {
  const bytes = new TextEncoder().encode(JSON.stringify(obj ?? {}));
  const binStr = String.fromCharCode(...bytes);
  return encodeURIComponent(btoa(binStr));
};

export function decode<T>(s: string | null, fallback: T): T {
  if (!s) return fallback;
  try {
    const binStr = atob(decodeURIComponent(s));
    const bytes = Uint8Array.from(binStr, c => c.charCodeAt(0));
    return JSON.parse(new TextDecoder().decode(bytes)) as T;
  } catch {
    return fallback;
  }
}
